import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const abnormalBloodPressure: AnswerPathTreeNode = {
  path: 'abnormalBloodPressure',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAbnormalBloodPressureDetails }],
};
